import { useLangContext } from "../../../providers/LangProvider/LangProviderContext";

const s = 1000;
const m = 60*s;
const h = 60*m;
const d = 24*h;
const twoDigitFormat = (digit: number): string => digit < 10 ? `0${digit}` : `${digit}`;

export const useConvertIntervalsToLocalString = () => {
    const { getLangPath } = useLangContext();
    const daysName = getLangPath('format.days_name.short');
    const hoursName = getLangPath('format.hours_name.short');
    const minutesName = getLangPath('format.minutes_name.short');
    const secondsName = getLangPath('format.seconds_name.short');
    const it_is_now = getLangPath('format.it_is_now');
    return [(interval: number) => {
        if (interval === 0) {
            return  it_is_now;
        }
        const days = Math.floor(interval / d);
        const hours = Math.floor((interval % d) / h);
        const reult = [];
        if (days) {
            reult.push(days, daysName);
        }
        if ((hours || days )) {
            reult.push(twoDigitFormat(hours), hoursName);
            if (days) {
                return reult.join(' ');
            }
        }
        const minutes = Math.floor((interval % h) / m);
      
        if ((minutes || hours)) {
            reult.push(twoDigitFormat(minutes), minutesName);
            if (hours) {
                return reult.join(' ');
            }
        }
        const seconds = Math.round((interval % m) / s);
        reult.push(twoDigitFormat(seconds), secondsName);
        return reult.join(' ');
    }]
}